export default __webpack_public_path__ + "static/media/up.f002f1df.svg";